export default class G60Helper {
    // enum: Top o Bottom
    static get POSICIONES() {
        return {
            TOP: 'top',
            BOTTOM: 'bottom'
        };
    }

    // enum: Rotacion 0 o 180
    static get ROTACION() {
        return {
            DEG0: 0,
            DEG180: 180
        };
    }

    constructor(app, configuration = null) {
        this.app = app;

        this.maxNiveles = 3;
        this.maxPosiciones = 0; // 0=ilimitado
        this.rotacion = G60Helper.ROTACION.DEG0;
        this.posicion = G60Helper.POSICIONES.TOP;
    }

    maxNiveles(){
        // TODO: el numero maximo de niveles depende de la solucion constructiva
        return 3
    }

    niveles() {
        // Calcular el numero de niveles que hay, recorriendo mainElementParameters
        // y buscando el mayor numero de nivel segun la key n-p
        // n=numero de nivel, p=posicion de la bandeja
        let maxNivel = 0;

        Object.entries(this.app.currentConfiguration.mainElementParameters).forEach(([key, value]) => {
            if (key.includes("-")) {
                let keyParts = key.split("-");
                let keyNivel = keyParts[0];

                if (parseInt(keyNivel) > maxNivel) {
                    maxNivel = parseInt(keyNivel);
                }
            }
        });

        return maxNivel;
    }
    listaNiveles() {
        // Para la lista de niveles, devolvemos Min(niveles()+1,maxNiveles)
        let niveles = Math.min(this.niveles() + 1, this.maxNiveles);
        // return array from 1 to this.niveles()
        if( this.esSuelo() ){
            return Array.from({ length: niveles }, (v, k) => k + 1).reverse();
        }
        return Array.from({ length: niveles }, (v, k) => k + 1);
    }

    esTecho() {
        let sol_constructiva = this.getSolucionConstructiva();

        switch (sol_constructiva.id) {
            case "80-portico_techo":
            case "80-techo_cartela":
            case "80-techo_bandera":
            case "80-semiportico_techo-pared":
                return true;
            default:
                return false;
        }
    }

    esSuelo() {
        let sol_constructiva = this.getSolucionConstructiva();

        switch (sol_constructiva.id) {
            case "80-portico_suelo":
            case "80-suelo_cartela":
            case "80-suelo_bandera":
            case "80-semiportico_suelo-pared":
                return true;
            default:
                return false;
        }
    }
    esPared() {
        let sol_constructiva = this.getSolucionConstructiva();

        switch (sol_constructiva.id) {
            case "80-semiportico_techo-pared":
            case "80-semiportico_suelo-pared":
            case "80-pared_cartela":
                return true;
            default:
                return false;
        }
    }
    getConfiguration(){
        if( !this.app.currentConfiguration ) return null;

        return this.app.currentConfiguration
    }
    getSolucionConstructiva() {
        return this.getConfiguration().familyParameters[
            "sol_constructiva"
        ].value
    }
    bandejasNivel(nivel = 0) {
        let configuration = this.app.currentConfiguration;
        let result = {}

        // Recorrer configuration.mainElementParameters (que es un objeto)
        Object.entries(configuration.mainElementParameters).forEach(([key, value]) => {
            // key, si esta en format n-p (n=numero de nivel, p=posicion de la bandeja)
            if (key.includes("-")) {
                let keyParts = key.split("-");
                let keyNivel = keyParts[0];
                let keyPosicion = keyParts[1];

                value.numero_nivel.value = keyNivel;
                value.posicion_bandeja.value = keyPosicion;
            } else {
                // change the key of the element to 1-1
                let newKey = "1-1";
                configuration.mainElementParameters[newKey] = value;
                delete configuration.mainElementParameters[key];

                // Que pasa si el value.numero_nivel.value es "" o null
                if (value.numero_nivel.value == null || value.numero_nivel.value === "") {
                    value.numero_nivel.value = 1;
                }
                // Si value.posicion_bandeja.value es "" o null
                if (value.posicion_bandeja.value == null || value.posicion_bandeja.value === "") {
                    value.posicion_bandeja.value = 1;
                }
            }

            // Campo numero_nivel
            if (value.numero_nivel.value == nivel) {
                result[key] = value;
            }
        });


        // configuration.mainElementParameters.forEach(element => {
        //     // Que pasa si el valor es "" o null
        //     if (element.numero_nivel.value == null) {
        //         element.numero_nivel.value = 1;
        //     }

        //     // Campo numero_nivel
        //     if (element.numero_nivel.value == nivel) {
        //         result.push(element);
        //     }

        // });

        return result
    }

    async añadirBandeja(nivel = 1) {
        let configuration = this.app.currentConfiguration;

        // Recuperar cuántas bandejas hay en el nivel
        let bandejas = this.bandejasNivel(nivel);
        let numeroBandejas = Object.keys(bandejas).length;
        await this.addMainElement(nivel, numeroBandejas + 1);
    }

    async addMainElement(row, column) {
        let newElementKey = row + "-" + column;

        await this.app.API.addMainElement(newElementKey);
    }

    async eliminarBandeja(nivel, posicion) {
        await this.removeElement(nivel, posicion);
    }


    async removeElement(row, column) {
        let elementKey = row + "-" + column;
        await this.removeElementByKey(elementKey);
    }
    async removeElementByKey(key) {
        delete this.app.currentConfiguration.mainElementParameters[
            key
        ];
    }

}
